import { Select } from "@mantine/core";
import {
  IAfterGuiAttachedParams,
  IDoesFilterPassParams,
} from "ag-grid-enterprise";
import { CustomFilterProps, useGridFilter } from "ag-grid-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";

export default ({ model, onModelChange, getValue }: CustomFilterProps) => {
  const refInput = useRef<HTMLInputElement>(null);
  const doesFilterPass = useCallback(
    (params: IDoesFilterPassParams) => {
      const { node } = params;
      const filterText: string = model;
      const value: string = getValue(node).toString().toLowerCase();
      // make sure each word passes separately, ie search for firstname, lastname
      const result = filterText
        .toLowerCase()
        .split(" ")
        .every((filterWord) => value.indexOf(filterWord) >= 0);
      return result;
    },
    [model]
  );

  const afterGuiAttached = useCallback((params?: IAfterGuiAttachedParams) => {
    if (!params || !params.suppressFocus) {
      // Focus the input element for keyboard navigation.
      // Can't do this in an effect,
      // as the component is not recreated when hidden and then shown again
      refInput.current?.focus();
    }
  }, []);

  // register filter handlers with the grid
  useGridFilter({
    doesFilterPass,
    afterGuiAttached,
  });

  const [dataDepartment, setDataDepartment] = useState<any[]>([]);

  const fetchDataDepartment = async () => {
    const res = await repositoryPos.get<MessageResponse<any[]>>(
      `/api/v1/TblDepartment/get-all`
    );

    if (res && res.success) {
      const result = res.data;

      const rawData = result
        .filter((i) => i.name && i.deparmentCode)
        .map((i) => ({ label: i.name, value: i.deparmentCode }));

      const uniqueData = [
        ...new Map(rawData.map((item) => [item.value, item])).values(),
      ];

      setDataDepartment(uniqueData);
    }
  };

  useEffect(() => {
    fetchDataDepartment();
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <Select
        searchable
        clearable
        comboboxProps={{
          transitionProps: { transition: "fade-up", duration: 200 },
        }}
        size="xs"
        mt={10}
        data={dataDepartment}
        multiple={true}
        onChange={(value) => {
          onModelChange({
            filter: value === null ? "" : value,
            filterType: "text",
            type: "contains",
          });
        }}
        width={"100%"}
        nothingFoundMessage="Dữ liệu không có !"
      />
    </div>
  );
};
